import LocalStorage from "../LocalStorage/LocalStorage";
import {useDispatch, useSelector} from "react-redux";
import {setSelectedManufacturersData} from "../../reducers/UserReducer/UserActions";
import {useMemo} from "react";

const useManufacturerData = () => {
	const dispatch = useDispatch();
	const selectedManufacturers = useSelector(({user}) => user.selectedManufacturers);
	const manufacturers = useMemo(() => LocalStorage.userManufacturerData.get(),[]);
	const manufacturerData = useMemo(() => LocalStorage.manufacturerData.get(),[]);
	const hasMultipleManufacturers = !!(manufacturers && manufacturers.length > 0);
	const selectedData = useMemo(
		() => (selectedManufacturers ?? []).map((m) => m?.value).filter(Boolean),
		[selectedManufacturers]
	);
	const userData = useMemo(
		() => (manufacturers ?? []).map((m) => m?.platform_id).filter(Boolean),
		[manufacturers]
	);

	const paramsData = useMemo(() => {
		if (!hasMultipleManufacturers) return [];
		return selectedData.length > 0 ? selectedData : userData;
	}, [hasMultipleManufacturers, selectedData, userData]);

	const manufacturerParams = useMemo(() => {
		if (hasMultipleManufacturers) {
			return { manufacturers: paramsData };
		}

		if (manufacturerData?.platform_id) {
			return { manufacturerPlatformId: manufacturerData.platform_id };
		}

		return {};
	}, [hasMultipleManufacturers, paramsData, manufacturerData]);

	const dataManagerByPlatformId = useMemo(() => {
		const map = new Map();
		(manufacturers ?? []).forEach((m) => {
			if (m?.platform_id) map.set(m.platform_id, m.data_manager_id);
		});
		return map;
	}, [manufacturers]);

	const dataManagersParams = useMemo(() => {
		if (hasMultipleManufacturers) {
			const dataManagers = paramsData
				.map((id) => dataManagerByPlatformId.get(id))
				.filter(Boolean);
			return { dataManagers };
		}

		if (manufacturerData?.data_manager_id) {
			return { dataManagerId: manufacturerData.data_manager_id };
		}

		return {};
	}, [
		hasMultipleManufacturers,
		paramsData,
		dataManagerByPlatformId,
		manufacturerData,
	]);

	const manufacturersOptionsMap = useMemo(() => {
		return manufacturers?.map((data) => {
			return (
				{ value: data?.platform_id, label: data?.nickname }
			);
		});
	}, [manufacturers]);

	const setSelectedManufacturers = (selectedManufacturers) => {
		const data = selectedManufacturers?.map((data) => {
			return (
				{ value: data?.platform_id, label: data?.nickname }
			);
		});

		dispatch(setSelectedManufacturersData(data));
	}

	return {
		hasMultipleManufacturers,
		manufacturerParams,
		dataManagersParams,
		manufacturersOptionsMap,
		setSelectedManufacturers
	};
}

export default useManufacturerData;
